var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("Title", {
        attrs: {
          pages: [{ icon: "fingerprint", page: _vm.page_title.toUpperCase() }],
        },
      }),
      _c(
        "v-container",
        { attrs: { fluid: "" } },
        [
          _c(
            "v-card",
            { staticClass: "pa-4" },
            [
              _c(
                "v-card",
                { staticClass: "pa-4", attrs: { outlined: "" } },
                [
                  _c("h3", { staticClass: "title font-weight-bold mb-3" }, [
                    _vm._v("Subir archivo de registros de fichadas"),
                  ]),
                  _c("p", [
                    _vm._v(
                      "Seleccioná el archivo con los registros de fichadas para procesar y ver el listado de ingresos y egresos."
                    ),
                  ]),
                  _c(
                    "v-row",
                    {
                      staticClass: "container-card",
                      attrs: { dense: "", justify: "center" },
                    },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", md: "5" } },
                        [
                          _c(
                            "div",
                            { staticClass: "mb-4" },
                            [
                              _c("font-awesome-icon", {
                                staticClass: "me-2",
                                attrs: { icon: ["fas", "file"] },
                              }),
                              _c(
                                "v-label",
                                { staticClass: "font-weight-bold ms-2" },
                                [_c("strong", [_vm._v("Archivo")])]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "card-file",
                              on: { click: _vm.triggerFile },
                            },
                            [
                              _c("font-awesome-icon", {
                                staticClass: "card-icon mb-2",
                                attrs: {
                                  icon: ["fas", "arrow-up-from-bracket"],
                                },
                              }),
                              !_vm.file
                                ? [
                                    _c("p", { staticClass: "mb-0" }, [
                                      _c("strong", [
                                        _vm._v("Haga clic para seleccionar"),
                                      ]),
                                    ]),
                                    _c("p", { staticClass: "mb-0 subtext" }, [
                                      _vm._v(
                                        "o arrastre y suelte su archivo aquí"
                                      ),
                                    ]),
                                    _c("p", { staticClass: "mb-0" }, [
                                      _vm._v(
                                        "Formatos soportados: CSV, Excel."
                                      ),
                                    ]),
                                  ]
                                : [
                                    _c("p", { staticClass: "mb-0" }, [
                                      _c("strong", [
                                        _vm._v(_vm._s(_vm.file.name)),
                                      ]),
                                    ]),
                                  ],
                            ],
                            2
                          ),
                          _c("v-file-input", {
                            ref: "fileInput",
                            staticClass: "d-none",
                            attrs: { accept: ".csv,.xlsx,.xls" },
                            model: {
                              value: _vm.file,
                              callback: function ($$v) {
                                _vm.file = $$v
                              },
                              expression: "file",
                            },
                          }),
                        ],
                        1
                      ),
                      _c("v-col", { attrs: { cols: "12", md: "10" } }, [
                        _vm.error
                          ? _c(
                              "div",
                              { staticClass: "mb-4 card-error d-flex" },
                              [
                                _c("font-awesome-icon", {
                                  staticClass: "mt-1 me-2",
                                  attrs: {
                                    icon: ["fas", "triangle-exclamation"],
                                  },
                                }),
                                _c("div", [
                                  _c("strong", [_vm._v("Archivo requerido")]),
                                  _c("br"),
                                  _vm._v(
                                    " Debe cargar un archivo para iniciar el proceso. "
                                  ),
                                ]),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]),
                      _c(
                        "v-col",
                        {
                          staticClass: "text-end",
                          attrs: { cols: "12", md: "10" },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { color: "primary" },
                              on: { click: _vm.processFiles },
                            },
                            [_vm._v("Procesar")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("DialogLoading", {
                attrs: { dialog: _vm.loading_process, text: "Procesando..." },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }